import { Link } from 'expo-router';

export function RouterLink(props: Parameters<typeof Link>[0]) {
  return (
    <Link
      {...props}
      asChild={false}
      style={{
        fontFamily: 'inherit',
      }}
    />
  );
}
